<!-- 资源位 -->
<template>
  <div>
    <div
      @click.capture="handleClick(i, index)"
      class="activityItem"
      v-for="(i, index) in resourceDetails"
      :key="i.id"
    >
      <ActivityBoardItem v-bind="i" />
    </div>
  </div>
</template>
<script>
import ActivityBoardItem from './PureActivityBoardItem';

export default {
  components: {
    ActivityBoardItem
  },
  props: {
    resourceCount: Number,
    resourceDetails: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleClick(data, index) {
      this.$emit('reportEvent', {
        event: 'component_resources_click',
        module_name: '活动资源',
        ad_position: index + 1,
        ad_name: data.remark || '无'
      });
    }
  },
  mounted() {
    this.$emit('reportEvent', {
      event: 'component_expo',
      module_name: '活动资源位'
    });
  }
};
</script>

<style lang="less" scoped>
.activityItem {
  margin: 0 auto;
  width: 100%;

  &:not(:first-child) {
    margin-top: 24px;
  }

  > img {
    width: 100%;
  }
}
</style>
